import {Fragment, React, StyledProps, withStyles, _ } from '@api'
import { CustomAttribute, Collapsible, TextInput, PrimaryButton, CentricTheme, ViewConfigMapping } from 'centric-ui-components'
import { Typography } from '@material-ui/core'
import { Link } from '@material-ui/icons'
import {  } from '@stores'

const styles = (theme: CentricTheme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#FAFAFA',
    marginBottom: '16px'
  },
  lastSync: {
    flex: 1
  },
  body2: {
    color: 'rgba(27, 27, 27, 0.54)',
    fontWeight: 'normal'
  },
  body1: {
    color: 'rgba(27, 27, 27, 0.87)',
    fontWeight: 'normal'
  },
  list: {
    backgroundColor: '#FAFAFA',
    padding: 16
  },
  wrapperInner: {
    backgroundColor: '#FAFAFA',
    padding: '0 16px'
  },
  rightWrapperInner: {
    backgroundColor: '#FFFFFF',
    padding: '0 24px'
  },
  rightSidebarList: {
    backgroundColor: '#FFFFFF',
    padding: '16px 24px 16px 24px'
  },
  icon: {
    height: '24px',
    width: '24px'
  }
})

interface MyProps extends StyledProps {
  open?: boolean
  title?: string
  onClickCollapseHeader?: (e, name) => void
  attributeDefinitions?: Array<any>
  data?: any
  mapping?: Array<any>
  onChangeInput?: (e) => void
  onCheckedChange?: (e) => void
  onChipDelete?: (e, id, attrDefn) => void
  editMode?: boolean,
  showSyncButton?: boolean
  showLastSync?: boolean
  time?: string
  onClickSync?: (e) => void
  onClickAddTag?: (e, data) => void
  updateSpec?: any
  onBlurSave?: (updateSpec, model, value) => void
  isRightSidebar?: boolean
}

export class PLMAttributesComponent extends React.Component<MyProps> {
  static defaultProps = {
    title: 'PLM Attributes',
    time: 'a moment ago',
    showLastSync: true,
  }
  render() {
    const {
      open,
      title,
      data,
      mapping,
      attributeDefinitions,
      classes,
      time,
      onClickSync,
      onChangeInput,
      onChipDelete,
      editMode,
      onClickCollapseHeader,
      showSyncButton,
      showLastSync,
      onClickAddTag,
      updateSpec,
      onBlurSave,
      isRightSidebar
    } = this.props
    let list = classes.list
    let wrapperInner = classes.wrapperInner 
    const synBtnDisabled = false // {merchProductSyncStatus:{synBtnDisabled}}=syncProgress
    if (isRightSidebar) {
      list = classes.rightSidebarList
      wrapperInner = classes.rightWrapperInner 
    }
    return <Collapsible classes={{ list, wrapperInner }} open={open} title={title} handleClick={(e) => { onClickCollapseHeader ? onClickCollapseHeader(e.target, 'PLMAttributes') : null }}>
      {mapping && mapping.length ?
        (<Fragment>
          {/** TODO: Figure out better implementation for last sync */}
          {showLastSync && <div className={classes.container}>
            <div className={classes.lastSync}>
              <Typography variant={'body1'} classes={{ body1: classes.body2 }}>{'Last Sync'}</Typography>
              <Typography classes={{ body1: classes.body1 }}>{time}</Typography>
            </div>
            {showSyncButton ? <PrimaryButton onClick={onClickSync} icon={{ position: 'left', component: <Link /> }}>Sync</PrimaryButton> : null}
          </div>}
          {_.map(mapping, (thisField: ViewConfigMapping, index) => {
            const attributeDefinition = _.find(attributeDefinitions, (definition) => definition.name === thisField.model)
            return (
              <CustomAttribute
                key={index}
                attributes={data.attributes}
                attributeDefinition={attributeDefinition}
                field={thisField}
                onChangeInput={onChangeInput}
                onChipDelete={onChipDelete}
                editMode={editMode}
                onClickAddTag={onClickAddTag}
                saveCustomAttribute={onBlurSave}
                updateSpec={updateSpec}
              />)
          })}
        </Fragment>) :
        (<Fragment>
          {showLastSync && <div className={classes.container}>
            <div className={classes.lastSync}>
              <Typography variant={'body1'} classes={{ body1: classes.body2 }}>{'Last Sync'}</Typography>
              <Typography classes={{ body1: classes.body1 }}>{time}</Typography>
            </div>
            {showSyncButton ? <PrimaryButton onClick={onClickSync} icon={{ position: 'left', component: <Link classes={{root: classes.icon}}
            /> }} disabled={synBtnDisabled}
            >Sync</PrimaryButton> : null}
          </div>}
          {!_.isUndefined(attributeDefinitions) && _.map(attributeDefinitions, (def) => {
            const attribute = data.attributes[def.name]

            return (
              <CustomAttribute
                key={def.id}
                attribute={attribute}
                onChangeInput={onChangeInput}
                onChipDelete={onChipDelete}
                editMode={editMode}
                attributeDefinition={def}
                onClickAddTag={onClickAddTag}
                saveCustomAttribute={onBlurSave}
                updateSpec={updateSpec}
              />
            )
          })}
        </Fragment>)
      }
    </Collapsible>
  }
}

@(withStyles as any)(styles)
export class PLMAttributes extends PLMAttributesComponent { }



// WEBPACK FOOTER //
// ./src/shared/components/ui/components/PLMAttributes.tsx